<template>
  <div class="purpose">

    <div class="purpose__bg" :class="{ 'purpose__bg--evaluation': start }"></div>

    <div transition="expand" class="purpose__container">

      <purpose-info v-if="!start">
        <button @click="startTraits" class="custom-btn custom-btn--green">Start</button>
      </purpose-info>

      <div v-else>
        <h1 class="network__traits-title text-center">Purpose</h1>
        <dots-number activeDots='1'/>
        <demo-indicators :indicators="indicatorsList" section="Purpose" sectionOrder="0"/>
      </div>

    </div>

  </div>
</template>

<script>
// API
import demoApi from '@/api/demo';
// Components
import PurposeInfo from '@/components/Evaluation/Purpose/Info';
import DotsNumber from '@/components/Evaluation/Dots';
import DemoIndicators from '@/components/Demo/Indicators';

export default {
  components: { PurposeInfo, DotsNumber, DemoIndicators },
  data() {
    return {
      start: false,
      indicatorsList: [],
      evaluationResults: {},
    };
  },
  methods: {
    startTraits() {
      this.start = true;
    },
  },
  created() {
    demoApi.index().then((response) => {
      const subjectObject = response.data.traits.filter(trait => trait.subject_name === 'Purpose');
      this.indicatorsList = subjectObject[0].indicators;
      // this.indicators = response.data.traits[2].indicators;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Demo/Purpose.vue